// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-9PpL","footer":"styles_footer__3-WUD","passCodeTooltip":"styles_passCodeTooltip__3QzVk"};